@if (operation) {
    <tec-collapse
        [icon]="'icon-card'"
        [title]="'PROCESSES.DETAIL.OCR' | translate"
        [tags]="[
            {
                label: ('MASTER.STATUS.' + operation.state | translate),
                status: masterService.getTagStatus(operation.state)
            }
        ]"
        [expanded]="expanded"
        (clickEvent)="toggleCollapse.emit($event)"
    >
        <!-- Un solo nodo proyectado → iconos en fila (varios ngProjectAs se apilan en columna). -->
        <div class="ocr-header-actions" ngProjectAs="tec-button-icon">
            @if (showUpdateIdentityFromOcr) {
                <tec-button-icon
                    icon="icon-refresh"
                    type="default"
                    size="sm"
                    [tooltip]="'PROCESSES.DETAIL.UPDATE_IDENTITY_FROM_OCR' | translate"
                    [disabled]="updateIdentityFromOcrLoading"
                    (clickEvent)="onUpdateIdentityFromOcrClick($event)"
                />
            }
            <app-developer-curl-button
                [path]="operationCurlPath"
                titleKey="PROCESSES.CURL_MODAL.TITLE_OPERATION"
            />
        </div>
        @if (loading && !contentReady) {
            <!-- SLOT_LOADING_OCR -->
            <tec-tile [type]="'loading'" [title]="'LOADING.PROCESS_DETAIL' | translate" />
        } @else if (operation.state !== OPERATION_STATUS.INIT && operation.state !== OPERATION_STATUS.NOT_STARTED) {
            <tec-tile [title]="'PROCESSES.DETAIL.DETAILS' | translate">
                <div class="grid grid-i3">
                    @if (operation.first_surnames && operation.second_surnames) {
                        <tec-info-group [label]="'PROCESSES.DETAIL.SURNAMES_1' | translate">
                            <span>{{ operation.first_surnames || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                            <ng-container
                                [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                                [ngTemplateOutletContext]="{ change: ocrFieldHistory('first_surnames') || ocrFieldHistory('surnames') }"
                            />
                        </tec-info-group>
                        <tec-info-group [label]="'PROCESSES.DETAIL.SURNAMES_2' | translate">
                            <span>{{ operation.second_surnames || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                            <ng-container
                                [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                                [ngTemplateOutletContext]="{ change: ocrFieldHistory('second_surnames') }"
                            />
                        </tec-info-group>
                    } @else {
                        <tec-info-group [label]="'PROCESSES.DETAIL.AEAT_MODAL.SURNAMES' | translate">
                            <span>{{ operation.surnames || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                            <ng-container
                                [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                                [ngTemplateOutletContext]="{ change: ocrFieldHistory('surnames') }"
                            />
                        </tec-info-group>
                    }
                    <tec-info-group [label]="'PROCESSES.DETAIL.NAME' | translate">
                        <span>{{ operation.names || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                        <ng-container
                            [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                            [ngTemplateOutletContext]="{ change: ocrFieldHistory('names') }"
                        />
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.NUM_DOCUMENT' | translate">
                        <span>
                            {{ operation.identifier || ('GENERAL.NOT_AVAILABLE' | translate) }}
                        </span>
                        <ng-container
                            [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                            [ngTemplateOutletContext]="{ change: ocrFieldHistory('identifier') }"
                        />
                        @if (operation.identifier) {
                            <ng-container [ngTemplateOutlet]="BLOCK_UNLOCK_ICONS"/>
                        }
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.TYPE_DOCUMENT' | translate">
                        <span>{{ masterService.getDocumentTypeLabel(operation.document_type) }}</span>
                        <ng-container
                            [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                            [ngTemplateOutletContext]="{ change: ocrFieldHistory('document_type') }"
                        />
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.EXPIRY_DATE' | translate">
                        <tec-icon name="icon-calendar"></tec-icon>
                        <span>
                            {{ (operation.expiration_date | expirationDate: 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}
                        </span>
                        <ng-container
                            [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                            [ngTemplateOutletContext]="{ change: ocrFieldHistory('expiration_date') }"
                        />
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.BIRTH_DATE' | translate">
                        <tec-icon name="icon-calendar"></tec-icon>
                        <span>
                            {{ (operation.birthdate | safeDate: 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}
                        </span>
                        @if (processHelper.ocrDocumentAgeKnown) {
                            <tec-tag [status]="processHelper.yearsOld >= 18 ? 'success' : 'warning'">
                                {{ 'PROCESSES.DETAIL.YEARS' | translate: {years_old: processHelper.yearsOld} }}
                            </tec-tag>
                        }
                        <ng-container
                            [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                            [ngTemplateOutletContext]="{ change: ocrFieldHistory('birthdate') }"
                        />
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.GENDER' | translate">
                        <span>{{ masterService.hasTranslation('MASTER.GENDERS.' + operation.gender) ? ('MASTER.GENDERS.' + operation.gender | translate) : (operation.gender ?? ('GENERAL.NOT_AVAILABLE' | translate)) }}</span>
                        <ng-container
                            [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                            [ngTemplateOutletContext]="{ change: ocrFieldHistory('gender') }"
                        />
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.NACIONALITY' | translate">
                        <span>
                            {{
                                masterService.hasTranslation('MASTER.COUNTRIES.' + operation.nationality) ?
                                ('MASTER.COUNTRIES.' + operation.nationality | translate) :
                                (operation.nationality ?? 'GENERAL.NO_INFO' | translate)
                            }}
                        </span>
                        <ng-container
                            [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                            [ngTemplateOutletContext]="{ change: ocrFieldHistory('nationality') }"
                        />
                    </tec-info-group>
                </div>
                <tec-divider></tec-divider>
                <span>
                    {{ ('PROCESSES.DETAIL.ADDRESS' | translate)?.toUpperCase() }}
                </span>
                <div class="grid grid-i3">
                    <tec-info-group [label]="'PROCESSES.DETAIL.ADDRESS' | translate">
                        <span>{{ (operation.address) || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                        <ng-container
                            [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                            [ngTemplateOutletContext]="{ change: ocrFieldHistory('address') }"
                        />
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.CITY' | translate">
                        <span>{{ (operation.municipality) || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                        <ng-container
                            [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                            [ngTemplateOutletContext]="{ change: ocrFieldHistory('municipality') }"
                        />
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.PROVINCE' | translate">
                        <span>{{ (operation.province) || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                        <ng-container
                            [ngTemplateOutlet]="FIELD_HISTORY_HINT"
                            [ngTemplateOutletContext]="{ change: ocrFieldHistory('province') }"
                        />
                    </tec-info-group>
                </div>
            </tec-tile>

            <tec-tile [title]="'PROCESSES.DETAIL.OPERATION' | translate">
                <div class="grid grid-i3">
                    <tec-info-group [label]="'PROCESSES.DETAIL.ID_OPERATION' | translate">
                        <tec-copy-text
                            [label]="processHelper.truncateUUID(operation.uuid)"
                            [labelToCopy]="operation.uuid"
                        ></tec-copy-text>
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.NUM_TRIED' | translate">
                        <tec-badge
                            [label]="operation.total_tries ? operation.total_tries?.toString() : ('GENERAL.NOT_AVAILABLE' | translate)"
                            type="square"
                        />
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.CAPTURE_METHOD' | translate">
                        <tec-tag>{{ ocrDetailCaptureMethodLabelKey(operation.capture_method, operation.mode) | translate }}</tec-tag>
                    </tec-info-group>
                    <!-- TODO GESTIONAR CUANDO SEA MANUAL -->
                    @if (validation === 'auto') {
                        <tec-info-group [label]="'PROCESSES.DETAIL.VERIFICATION' | translate">
                            <tec-tag [label]="`PROCESSES.DETAIL.AUTOMATIC` | translate"></tec-tag>
                        </tec-info-group>
                    }
                </div>
                <tec-divider></tec-divider>
                <div class="grid grid-i3">
                    <tec-info-group [label]="'PROCESSES.DETAIL.START_DATE' | translate">
                        <tec-icon name="icon-calendar"></tec-icon>
                        <span>{{ (operation.start_at | safeDate: 'dd/MM/yyyy - HH:mm') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.END_DATE' | translate">
                        <tec-icon name="icon-calendar"></tec-icon>
                        <span>{{ (operation.end_at | safeDate: 'dd/MM/yyyy - HH:mm') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                    </tec-info-group>
                    <tec-info-group [label]="'PROCESSES.DETAIL.DURATION' | translate">
                        <tec-icon name="icon-clock" size="xs" />
                        <span>{{ formatSecondsToMinutes(operation.total_time) || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                    </tec-info-group>
                </div>
            </tec-tile>
        } @else {
            <tec-empty-state
                [title]="'GENERAL.NO_DATA' | translate"
                [size]="'default'"
                [type]="'empty'"
            ></tec-empty-state>
        }
    </tec-collapse>
}

<ng-template #FIELD_HISTORY_HINT let-change="change">
    @if (change) {
        <tec-popover
            class="field-history-hint"
            data-testid="field-history-hint"
            [title]="'PROCESSES.DETAIL.FIELD_EDIT_INFO_TITLE' | translate"
            triggerMode="hover"
        >
            <tec-icon tecPopoverTrigger name="icon-return-nav-state"></tec-icon>
            <tec-info-group [label]="'PROCESSES.DETAIL.FIELD_ORIGINAL_VALUE' | translate">
                <span>{{ formatFieldHistoryPreviousValue(change) }}</span>
            </tec-info-group>
            <tec-divider></tec-divider>
            <tec-info-group [label]="'PROCESSES.DETAIL.FIELD_EDITOR' | translate">
                <tec-icon name="icon-user"></tec-icon>
                <span>{{ change.actor?.name ?? ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
            </tec-info-group>
            <tec-divider></tec-divider>
            <tec-info-group [label]="'PROCESSES.DETAIL.FIELD_DATE' | translate">
                <tec-icon name="icon-calendar"></tec-icon>
                <span>
                    {{
                        (change.occurred_at | safeDate: 'dd/MM/yyyy - HH:mm') ||
                            ('GENERAL.NOT_AVAILABLE' | translate)
                    }}
                </span>
            </tec-info-group>
        </tec-popover>
    }
</ng-template>

<ng-template #BLOCK_UNLOCK_ICONS let-defaultBlocks="defaultBlocks" let-defaultUnblocks="defaultUnblocks">
    @for (menu of (processDetail ? processHelper.detailMenuOpt(processDetail, false) : []); track $index) {
        @if (menu.id === menuItemAction.BLOCK) {
            <tec-button-icon
                icon="icon-lock"
                size="sm"
                [tooltip]="'BUTTON.BLOCK' | translate"
                (click)="onIdentityMenu(menu, defaultBlocks || [])"
            />
        }
        @if (menu.id === menuItemAction.UNLOCK) {
            <tec-button-icon
                icon="icon-unlock"
                size="sm"
                [tooltip]="'BUTTON.UNBLOCK' | translate"
                (click)="onIdentityMenu(menu, defaultUnblocks || [])"
            />
        }
    }
</ng-template>
